








import { Component, Prop, Vue } from 'vue-property-decorator';
import { IMentoringTopCard } from './types';

@Component
export default class MentoringTopCard extends Vue implements IMentoringTopCard {
  @Prop({ type: String, default: '' })
  readonly status!: string;

  @Prop({ type: String, default: '' })
  readonly teamTitle!: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/programcard/components/top/MentoringTopCard.vue